module.exports = __webpack_public_path__ + "img/danyart.a17ba67b.webp";